import React, { useEffect, useMemo } from 'react';

import { THEMES } from '../constants';

const initialState = {
  theme: THEMES.DEFAULT,
};

const ThemeContext = React.createContext(initialState);

const ThemeProvider = ({ children }) => {
  const [theme, _setTheme] = React.useState(initialState.theme);

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');

    if (storedTheme) {
      _setTheme(JSON.parse(storedTheme));
    }
  }, []);

  const setTheme = (newTheme) => {
    localStorage.setItem('theme', JSON.stringify(newTheme));
    _setTheme(newTheme);
  };

  const themeContextValue = () =>
    useMemo(
      () => ({
        theme,
        setTheme,
      }),
      [],
    );

  return <ThemeContext.Provider value={themeContextValue()}>{children}</ThemeContext.Provider>;
};

export { ThemeProvider, ThemeContext };
